import { SITE_URL, WEBSITE_NAME } from '../constants'
import { organizationAuthor, organizationPublisher } from '../organization'
import { buildBreadcrumbList } from './breadcrumb'

export interface CaseStudySchemaInput {
  slug: string
  pageTitle: string
  description: string
  headline: string
  alternativeHeadline: string
  primaryImage: string
  images: string[]
  clientName: string
  breadcrumbLabel: string
}

export const buildCaseStudySchema = (input: CaseStudySchemaInput) => {
  const pageUrl = `${SITE_URL}/cases/${input.slug}/`

  return {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'WebPage',
        '@id': pageUrl,
        url: pageUrl,
        name: input.pageTitle,
        description: input.description,
        inLanguage: 'ja',
        isPartOf: {
          '@type': 'WebSite',
          name: WEBSITE_NAME,
          url: `${SITE_URL}/`,
        },
        primaryImageOfPage: {
          '@type': 'ImageObject',
          url: input.primaryImage,
        },
        publisher: organizationPublisher,
        breadcrumb: { '@id': `${pageUrl}#breadcrumb` },
        mainEntity: { '@id': `${pageUrl}#article` },
      },
      {
        '@type': 'Article',
        '@id': `${pageUrl}#article`,
        headline: input.headline,
        alternativeHeadline: input.alternativeHeadline,
        description: input.description,
        url: pageUrl,
        inLanguage: 'ja',
        image: input.images,
        author: organizationAuthor,
        publisher: organizationPublisher,
        about: {
          '@type': 'Organization',
          name: input.clientName,
        },
        mainEntityOfPage: { '@id': pageUrl },
      },
      buildBreadcrumbList(pageUrl, [
        { name: 'ホーム', item: `${SITE_URL}/` },
        { name: '事例', item: `${SITE_URL}/cases/` },
        { name: input.breadcrumbLabel, item: pageUrl },
      ]),
    ],
  }
}
